import React, { useState } from "react";
import axios from "axios";
import LocationSearch from "../components/LocationSearch";

const DistancePage = () => {
  const [pickup, setPickup] = useState(null);
  const [dropoff, setDropoff] = useState(null);
  const [distance, setDistance] = useState(null);

  const calculateDistance = async () => {
    if (!pickup || !dropoff) {
      alert("Select both locations");
      return;
    }

    try {
      const url = `https://router.project-osrm.org/route/v1/driving/${pickup.lon},${pickup.lat};${dropoff.lon},${dropoff.lat}?overview=false`;

      const res = await axios.get(url);

      const km = (
        res.data.routes[0].distance / 1000
      ).toFixed(2);

      setDistance(km);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Distance Calculator</h2>

      <LocationSearch
        placeholder="Pickup Location"
        onSelect={setPickup}
      />

      <br />

      <LocationSearch
        placeholder="Drop Location"
        onSelect={setDropoff}
      />

      <br />

      <button onClick={calculateDistance}>
        Calculate Distance
      </button>

      {distance && (
        <h3>
          Distance: {distance} KM
        </h3>
      )}
    </div>
  );
};

export default DistancePage;